import logError from 'helpers/logError';
import logWarning from 'helpers/logWarning';
import shouldRaiseError from 'logging/shouldRaiseError';

export default (error, info = null) => {
  const { message } = error;

  if (!shouldRaiseError(error)) {
    logWarning(message, info);
  } else {
    logError(message ?? error, info);
  }
};
